import React from 'react';
import { Link } from 'react-router-dom';
import { HammerIcon, GlassesIcon, RefreshCwIcon, WalletIcon, InfinityIcon } from 'lucide-react';
import { guaranteePoints, GuaranteePoint, WARRANTY_LINE } from '../data/product';
import { GoldMedal } from './LifetimeSeal';
import { CtaButton } from './CtaButton';
const icons: Record<GuaranteePoint['icon'], React.ComponentType<{
  className?: string;
}>> = {
  hammer: HammerIcon,
  lens: GlassesIcon,
  repeat: RefreshCwIcon,
  wallet: WalletIcon
};
export function GuaranteeSection() {
  return <section id="guarantee" className="scroll-mt-28 border-b border-white/10 bg-ink-950" data-id="element-549" data-mp="nskvlzpnlonu">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-550" data-mp="sm5iavlsqw7q">
        <div className="border-2 gold-edge bg-ink-900" data-id="element-551" data-mp="xivxlgps1ns3">
          <div className="relative gold-plate px-6 py-6 text-ink-950 lg:px-10 lg:py-8 lg:pr-56" data-id="element-552" data-mp="12j0gtei2kwm0">
            <Link to="/legal/guarantee" aria-label="Read the Lifetime Replacement Warranty terms" className="absolute right-8 top-1/2 hidden -translate-y-1/2 items-center transition-transform duration-150 ease-grit hover:-translate-y-[calc(50%+3px)] focus:outline-none focus-visible:ring-2 focus-visible:ring-ink-950 lg:flex" data-id="element-553" data-mp="12h7ay1fa6gf2">
              <GoldMedal size={140} data-id="element-554" data-mp="1vvtx6pp2hgyu" />
            </Link>
            <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.24em]" data-id="element-555" data-mp="1rt7cr9uq6ybo">
              <InfinityIcon className="h-4 w-4" aria-hidden="true" data-id="element-556" data-mp="2ohde9nwcpalq" />
              The GritVue lifetime promise
            </p>
            <h2 className="grit-headline mt-3 text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase" data-id="element-557" data-mp="2jk3na3tbcqvs">
              Break it.
              <br data-id="element-558" data-mp="2ar07hov741xz" />
              We replace it. For life.
            </h2>
            <p className="mt-3 max-w-2xl text-base font-bold sm:text-lg" data-id="element-559" data-mp="2aoxf4y6klwq3">
              Buy your X1 once. If it ever breaks, cracks, stops charging or you scratch a lens, we send you a
              replacement unit, for as long as you own it. Terms apply.
            </p>
            <p className="mt-4 inline-flex bg-ink-950 px-4 py-2.5 font-display text-lg font-extrabold uppercase leading-tight tracking-wide text-[#ffe79a] sm:text-2xl" data-id="element-560" data-mp="10lyts93e5yis">
              You never buy work glasses or a headlamp again. Ever.
            </p>
          </div>

          <ul className="grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-561" data-mp="vtfgld8m95ei">
            {guaranteePoints.map(point => {
            const Icon = icons[point.icon];
            return <li key={point.title} className="flex h-full flex-col bg-ink-900 p-6" data-id="element-562" data-mp="mtivtmpckqoq">
                  <Icon className="h-7 w-7 text-[#f2c94c]" aria-hidden="true" data-id="element-563" data-mp="7w8dbteaekji" />
                  <h3 className="mt-5 font-display text-2xl font-bold uppercase leading-tight text-offwhite" data-id="element-564" data-mp="cv33jgel3bdn">
                    {point.title}
                  </h3>
                  <p className="mt-2 text-[15px] text-steel-400" data-id="element-565" data-mp="22aj2y42phiqc">{point.body}</p>
                </li>;
          })}
          </ul>

          <div className="flex flex-col gap-5 border-t border-white/10 p-6 lg:flex-row lg:items-center lg:justify-between lg:p-10" data-id="element-566" data-mp="3rqvcl2nyiadj">
            <p className="grit-headline text-[clamp(1.75rem,5vw,3rem)] font-extrabold uppercase text-offwhite" data-id="element-567" data-mp="3mt39dchv31u1">
              You will never pay for
              <br data-id="element-568" data-mp="5dd7p60cn9mo" />
              <span className="gold-text" data-id="element-569" data-mp="l3lo12cutpo">work light again.</span>
            </p>
            <CtaButton offer="trio" className="w-full lg:w-auto" data-id="element-570" data-mp="ec8gmpus2xto">Get 3 X1 Systems for $99.90</CtaButton>
          </div>

          <p className="border-t border-white/5 px-6 pb-5 text-[11px] leading-relaxed text-steel-600 lg:px-10" data-id="element-571" data-mp="ab6eo19h87o0">
            {WARRANTY_LINE} Original purchaser, damage and functional failure.{' '}
            <Link to="/legal/guarantee" className="underline hover:text-steel-400" data-id="element-572" data-mp="jatietpohpk8">
              Full terms
            </Link>
            .
          </p>
        </div>
      </div>
    </section>;
}